import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { BaseNotification } from "@models/notification.model";

@Injectable({
    providedIn: "root",
})
export class NotificationService {
    constructor(private http: HttpClient) {}

    public saveNotification(): Observable<BaseNotification> {
        return this.http.post<BaseNotification>(`${environment.apiUrlBasePath}/notifications/save`, {});
    }

    public getNotifications(
        pageSize: number = environment.dynamicPagination.pageSize,
        userId: number,
        skipNotifications?: number,
    ): Observable<{ count: number; rows: Notification[]; totalUnreadCount: number }> {
        return this.http.get<{ count: number; rows: Notification[]; totalUnreadCount: number }>(
            `${environment.apiUrlBasePath}/notifications/getNotification?&pageSize=${pageSize}&userId=${userId}&skipNotifications=${skipNotifications}`,
        );
    }

    public markAsViewednotification(id: number): Observable<{ message: string }> {
        return this.http.patch<{ message: string }>(`${environment.apiUrlBasePath}/notifications/viewed/?id=${id}`, {});
    }

    public deleteNotifications(ids: number[]): Observable<{ message: string }> {
        const params = ids.map((id) => `ids=${id}`).join("&");
        return this.http.delete<{ message: string }>(`${environment.apiUrlBasePath}/notifications/delete?${params}`);
    }
}
